import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';
import VolumeDiscountForm, { buildPayload, validateForm } from './VolumeDiscountForm';

const EditVolumeDiscountDialog = ({ open, onClose, rule, onSave }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formState, setFormState] = useState({ formData: {}, tiers: [] });

  const handleClose = () => {
    if (loading) return;
    setError('');
    onClose();
  };

  const handleSubmit = async () => {
    setError('');
    const { formData, tiers } = formState;
    const validationError = validateForm(formData, tiers);
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    try {
      const payload = buildPayload(formData, tiers);
      const response = await fetch(`https://elnaf.fi/apiElnaf/api/volume_discounts.php?id=${rule.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (response.ok && (data.success || data.status === 'success')) {
        await onSave();
      } else {
        setError(data.message || data.error || 'Failed to update rule');
      }
    } catch (err) {
      console.error('Error updating rule:', err);
      setError('Network error — please try again');
    } finally {
      setLoading(false);
    }
  };

  if (!rule) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ borderBottom: '1px solid #e5e7eb', fontWeight: 600 }}>
        Edit Volume Discount Rule
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <VolumeDiscountForm initialData={rule} onChange={setFormState} />
      </DialogContent>
      <DialogActions sx={{ borderTop: '1px solid #e5e7eb', p: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} color="inherit" />}
          sx={{
            backgroundColor: '#845adf',
            '&:hover': { backgroundColor: '#6c48c5' }
          }}
        >
          {loading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditVolumeDiscountDialog;
